module.exports = __webpack_public_path__ + "static/media/first-page-slide6.b8786706.jpg";